module.exports = __webpack_public_path__ + "static/media/BGP-CHH.9da77fbb.jpg";